import { routes } from "routes/path"

const breadcrumbs = {
  [routes.dashboard]: {
    title: "Dashboard",
    breadcrumbItem: "Dashboard",
  },
  [routes.userList]: {
    title: "Users",
    breadcrumbItem: "Users",
    parentLink: routes.userList,
  },
  [routes.taskTitle]: {
    title: "Task Title",
    breadcrumbItem: "Task Title",
    parentLink: routes.taskTitle,
  },
  [routes.leadType]: {
    title: "Lead Type",
    breadcrumbItem: "Lead Type",
    parentLink: routes.leadType,
  },
  [routes.task]: {
    title: "Task",
    breadcrumbItem: "Task",
    parentLink: routes.task,
  },
  [routes.lead]: {
    title: "Lead",
    breadcrumbItem: "Lead",
    parentLink: routes.lead,
  },
  [routes.appointment]: {
    title: "Appointment",
    breadcrumbItem: "Appointment",
    parentLink: routes.appointment,
  },
  [routes.parcel]: {
    title: "Parcel",
    breadcrumbItem: "Parcel",
    parentLink: routes.parcel,
  },
  [routes.making]: {
    title: "Making",
    breadcrumbItem: "Making",
    parentLink: routes.making,
  },
  [routes.CustomerAttend]: {
    title: "Customer Attend",
    breadcrumbItem: "Customer Attend",
    parentLink: routes.CustomerAttend,
  },
  [routes.helpNeeded]: {
    title: "Help Needed",
    breadcrumbItem: "Help Needed",
    parentLink: routes.helpNeeded,
  },
  [routes.additionalWork]: {
    title: "Additional Work",
    breadcrumbItem: "Additional Work",
    parentLink: routes.additionalWork,
  },
  [routes.improvement]: {
    title: "Improvement",
    breadcrumbItem: "Improvement",
    parentLink: routes.improvement,
  },
  [routes.dcHanging]: {
    title: "DC Hanging",
    breadcrumbItem: "DC Hanging",
    parentLink: routes.dcHanging,
  },
  [routes.dbBackup]: {
    title: "Db-Backup",
    breadcrumbItem: "Db-Backup",
  },
  [routes.taskReport]: {
    title: "Task Report",
    breadcrumbItem: "Task Report",
  },
  [routes.fabric]: {
    title: "Requirement",
    breadcrumbItem: "Requirement",
  },
  [routes.rentmakinglist]: {
    title: "Un-Bill",
    breadcrumbItem: "Un-Bill",
  },
  [routes.rentmakingcreate]: {
    parent: "Un-Bill",
    breadcrumbItem: "Un-Bill Create",
    parentLink: routes.rentmakinglist,
  },
  [routes.rentmakingupdate]: {
    parent: "Un-Bill",
    breadcrumbItem: "Un-Bill Update",
    parentLink: routes.rentmakinglist,
  },
  [routes.categories]: {
    title: "Categories",
    breadcrumbItem: "Categories",
  },
  [routes.occasion]: {
    title: "Occasion",
    breadcrumbItem: "Occasion",
  },
  [routes.whatsAppMessage]: {
    title: "WhatsApp Message",
    breadcrumbItem: "WhatsApp Message",
  },
  [routes.sendMessgae]: {
    title: "SOP",
    breadcrumbItem: "SOP",
  },
  [routes.unBillReport]: {
    title: "Un-Bill Report",
    breadcrumbItem: "Un-Bill Report",
  },
  [routes.customerAttendReport]: {
    title: "Customer Attend Report",
    breadcrumbItem: "Customer Attend Report",
  },
  [routes.vendors]: {
    title: "Vendors",
    breadcrumbItem: "Vendors",
  },
  [routes.purchaseBill]: {
    title: "Purchase Bill",
    breadcrumbItem: "Purchase Bill",
  },
  [routes.handWork]: {
    title: "Hand Work",
    breadcrumbItem: "Hand Work",
  },
  [routes.otherCost]: {
    title: "Other Cost",
    breadcrumbItem: "Other Cost",
  },
  [routes.workers]: {
    title: "Workers",
    breadcrumbItem: "Workers",
  },
  [routes.stitchingWorkers]: {
    title: "Stitching Workers",
    breadcrumbItem: "Stitching Workers",
  },
  [routes.stitchingMasters]: {
    title: "Stitching Masters",
    breadcrumbItem: "Stitching Masters",
  },
  [routes.handWorkOrder]: {
    title: "Hand Work Order",
    breadcrumbItem: "Hand Work Order",
  },
  [routes.designerOrder]: {
    title: "Designer Order",
    breadcrumbItem: "Designer Order",
  },
  [routes.stitchingOrder]: {
    title: "Stitching Order",
    breadcrumbItem: "Stitching Order",
  },
  [routes.workerHoliday]: {
    title: "Worker Holiday",
    breadcrumbItem: "Worker Holiday",
  },
  [routes.setting]: {
    title: "Setting",
    breadcrumbItem: "Setting",
  },
  [routes.leave]: {
    title: "Employee Leave",
    breadcrumbItem: "Employee Leave",
  },
  [routes.employeeSalary]: {
    title: "Employee Salary",
    breadcrumbItem: "Employee Salary",
  },
  [routes.attendanceLog]: {
    title: "Attendance Log",
    breadcrumbItem: "Attendance Log",
  },
  [routes.advanceLog]: {
    title: "Advance Log",
    breadcrumbItem: "Advance Log",
  },
  [routes.attendanceReport]: {
    title: "Attendance Monthly Report",
    breadcrumbItem: "Attendance Monthly Report",
  },
  [routes.attendanceUser]: {
    title: "Attendance User",
    breadcrumbItem: "Attendance User",
  },
  [routes.dailyAttendanceReport]: {
    title: "Attendance Daily Report",
    breadcrumbItem: "Attendance Daily Report",
  },
  [routes.rackshelf]: {
    title: "Rack Shelf",
    breadcrumbItem: "Rack Shelf",
  },
  [routes.khaKhaRack]: {
    title: "Kha-Kha Rack",
    breadcrumbItem: "Kha-Kha Rack",
  },
  [routes.materialRack]: {
    title: "Material Rack",
    breadcrumbItem: "Material Rack",
  },
  [routes.drawRequirement]: {
    title: "Draw Requirement",
    breadcrumbItem: "Draw Requirement",
  },
  [routes.cuttingRequirement]: {
    title: "Cutting Requirement",
    breadcrumbItem: "Cutting Requirement",
  },
}

export default breadcrumbs
